import React, {Fragment} from 'react';
import {translate} from 'react-i18next';
import ProjectApi from "../../apis/ProjectApi";

class AddProject extends React.Component {

    defaultState = {
        loading: false,
        isOpen: false,
        displayName: '',
        active: true,
        errors: {}
    };

    state = this.defaultState;

    cancel = () => {
        this.setState(this.defaultState);
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({loading: true, errors: {}});
        ProjectApi.addProject({displayName: this.state.displayName, active: this.state.active})
            .then((response) => {
                if(response.status === 200) {
                    this.setState({loading: false});
                    if(response.data.success === true) {
                        this.cancel();
                        this.props.onSuccess();
                    } else {
                        this.setState({errors: response.data.errors});
                    }
                }
            })
    };

    render() {
        const {t} = this.props;
        return (
            <Fragment>
                <button className="btn btn-primary" onClick={() => this.setState({isOpen: true})}>
                    <i className="fa fa-plus m-r-xs"/>
                    {t('projectManagement.add.button.label')}
                </button>
                {this.state.isOpen ? (
                    <div className="AddDialog modal inmodal in text-left" tabIndex="-1" role="dialog" style={{display: 'block'}}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button className="close" onClick={this.cancel}>
                                        <span>x</span>
                                    </button>
                                    <h4 className="modal-title">
                                        {t('projectManagement.add.dialog.title')}
                                    </h4>
                                </div>
                                <form onSubmit={this.handleSubmit}>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-xs-12">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.name) ? ' has-error' : '')}>
                                                    <label>{t('projectManagement.add.dialog.displayName.label')}</label>
                                                    <input className="form-control" type="text" name="displayName"
                                                           value={this.state.displayName}
                                                           onKeyPress={(e) => { e.key === 'Enter' && this.handleSubmit; }}
                                                           onChange={(e) => this.setState({displayName: e.target.value})}/>
                                                    {(this.state.errors && this.state.errors.displayName) ? (
                                                        <span className="help-block">
                                                            {t('projectManagement.add.dialog.displayName.error.' + this.state.errors.displayName)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-12">
                                                <div
                                                    className={"form-group" + ((this.state.errors && this.state.errors.active) ? ' has-error' : '')}>
                                                    <div className="checkbox checkbox-default">
                                                        <input type="checkbox" name="active"
                                                               id="addProject-active-checkbox"
                                                               checked={this.state.active}
                                                               onChange={(e) => this.setState({active: e.target.checked})}/>
                                                        <label
                                                            htmlFor="addProject-active-checkbox">{t('projectManagement.add.dialog.active.checkbox.label')}</label>
                                                    </div>

                                                    {(this.state.errors && this.state.errors.active) ? (
                                                        <span className="help-block">
                                                            {t('projectManagement.add.dialog.active.error.' + this.state.errors.active)}
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-default" type="button" onClick={this.cancel}>
                                            {t('default.cancel')}
                                        </button>
                                        <button className="btn btn-primary" type="submit" disabled={this.state.loading}>
                                            {this.state.loading ? (
                                                <i className='fa fa-spinner fa-spin inline-block m-r'/>
                                            ) : null}
                                            {t('default.save')}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                ) : null}
            </Fragment>
        )
    }
}

export default translate()(AddProject);
